<script setup lang="ts">
import { CollectionAccount } from '../types'
import { ExoticActivity } from '../enums/activities'
import { PlatformIcon } from '@wastedondestiny/destiny-library'

withDefaults(defineProps<{
  account: CollectionAccount,
  activity?: ExoticActivity,
  hasExotic?: boolean,
  hasNoAccess?: boolean,
  activities?: Record<string, number>,
  repeatable?: boolean,
  noCount?: boolean,
  loading?: boolean,
}>(), {
  hasExotic: false,
  hasNoAccess: false,
  repeatable: false,
  noCount: false,
  loading: false
})
</script>

<template>
  <div class="w-full py-0.5 px-2 rounded-2xl flex justify-between items-center border-2" :class="{
    'bg-emerald-300 border-emerald-300': hasExotic,
    'bg-yellow-200 border-yellow-200': !hasExotic,
    'border-dashed bg-opacity-50': hasNoAccess,
  }">
    <span class="flex items-center justify-between w-full pr-1 text-black">
      <span class="flex items-center gap-1 text-sm">
        <PlatformIcon :account="account" />
        <slot />
      </span>
      <template v-if="!noCount">
        <span v-if="loading" class="text-xs -mr-1">
          LOADING
        </span>
        <span v-else-if="repeatable && !activity?.isGuaranteed" class="text-xs -mr-1">
          {{ activities ? Object.values(activities).reduce((a, b) => a + b, 0) : 0 }}
        </span>
        <span v-else-if="activity?.isGuaranteed" class="h-4 -mr-1">
          <span class="text-3xl w-2.5 leading-3 inline-block" :class="{
            'opacity-25': !(activities ? Object.values(activities).reduce((a, b) => a + b, 0) : 0),
            'opacity-100': !!(activities ? Object.values(activities).reduce((a, b) => a + b, 0) : 0)
          }">&bullet;</span>
        </span>
        <span v-else-if="!!activity" class="h-4 -mr-1">
          <span v-for="char in account.characters" class="text-3xl w-2.5 leading-3 inline-block"
            :class="{ 'opacity-25': !activities?.[char.characterId], 'opacity-100': activities?.[char.characterId] }">&bullet;</span>
        </span>
      </template>
    </span>
  </div>
</template>
